/* eslint-disable react/jsx-filename-extension */
import { PropsWithChildren, memo } from 'react'
import { useInit } from '../../init'

export const InitContainer = memo<PropsWithChildren>(({ children }) => {
  const initResult = useInit()

  if (initResult === false) return null

  return children
})

InitContainer.displayName = 'InitContainer'
